import { useCustomePanal } from './useCustomePanal'
import pageHeadCompact from '@/assets/customLayout/pageHeadCompact.svg'
import pageHeadLoose from '@/assets/customLayout/pageHeadLoose.svg'
import navPositionNormal from '@/assets/customLayout/navPositionNormal.svg'
import navPositionFloat from '@/assets/customLayout/navPositionFloat.svg'
import navPositionBottom from '@/assets/customLayout/navPositionBottom.svg'
import navLayoutNormal from '@/assets/customLayout/navLayoutNormal.svg'
import navLayoutSimple from '@/assets/customLayout/navLayoutSimple.svg'
import navLayoutVertical from '@/assets/customLayout/navLayoutVertical.svg'

export interface ICustomItem {
  id?: number
  key: string
  imgUrl: string
  des: string
  tag?: string
  onSelect?: () => void
}
const { handleLayoutChange: PCHandleLayoutChange } = useCustomePanal('pc')
const { handleLayoutChange: H5HandleLayoutChange } = useCustomePanal('h5')
// PC端布局弹框数据 防止后期数据变动
const pcCustompageHeadList: ICustomItem[] = [
  {
    key: 'compact',
    des: '紧凑',
    imgUrl: pageHeadCompact,
    onSelect: () => PCHandleLayoutChange('isEase', 'false')
  },
  {
    key: 'loose',
    des: '宽松',
    imgUrl: pageHeadLoose,
    onSelect: () => PCHandleLayoutChange('isEase', 'true')
  }
]
const pcCustomNavPositionList: ICustomItem[] = [
  {
    key: 'top',
    des: '横向',
    imgUrl: navPositionNormal,
    onSelect: () => PCHandleLayoutChange('navBarPosition', 'top')
  },
  {
    key: 'float',
    des: '竖向',
    imgUrl: navPositionFloat,
    onSelect: () => PCHandleLayoutChange('navBarPosition', 'float')
  }
]
const pcCustomNavLayoutList: ICustomItem[] = [
  {
    key: 'normal',
    des: '左图标+右文字',
    imgUrl: navLayoutNormal,
    onSelect: () => PCHandleLayoutChange('navContentLayout', 'normal')
  },
  {
    key: 'simple',
    des: '纯文字',
    imgUrl: navLayoutSimple,
    onSelect: () => PCHandleLayoutChange('navContentLayout', 'simple')
  }
]
// TODO PC端主题相关数据

// H5端布局弹框数据 防止后期数据变动
const h5CustomNavPositionList: ICustomItem[] = [
  {
    key: 'top',
    des: '顶部',
    imgUrl: navPositionNormal,
    onSelect: () => H5HandleLayoutChange('navBarPosition', 'top')
  },
  {
    key: 'float',
    des: '底部',
    imgUrl: navPositionBottom,
    onSelect: () => H5HandleLayoutChange('navBarPosition', 'float')
  }
]
const h5CustomNavLayoutList: ICustomItem[] = [
  {
    key: 'normal',
    des: '左图标+右文字',
    imgUrl: navLayoutNormal,
    onSelect: () => H5HandleLayoutChange('navContentLayout', 'normal')
  },
  {
    key: 'simple',
    des: '纯文字',
    imgUrl: navLayoutSimple,
    onSelect: () => H5HandleLayoutChange('navContentLayout', 'simple')
  },
  {
    key: 'vertical',
    des: '上图标+下文字',
    imgUrl: navLayoutVertical,
    onSelect: () => H5HandleLayoutChange('navContentLayout', 'vertical')
  }
]
// TODO H5端主题相关数据

export {
  pcCustompageHeadList,
  pcCustomNavPositionList,
  pcCustomNavLayoutList,
  h5CustomNavPositionList,
  h5CustomNavLayoutList
}
